import React, { useMemo } from 'react';

const CLD = 'https://res.cloudinary.com/dpppkdhdk/image/upload/f_auto,q_auto';

const MONTHLY_IMAGES_DAY = {
  0: `${CLD}/v1774894571/imagen_definitiva_origen_ENERO_crjjuq.png`,
  1: `${CLD}/v1774894570/imagen_definitiva_origen_FEBRERO_x92vlv.png`,
  2: `${CLD}/v1774894569/imagen_definitiva_origen_MARZO_zfckcy.png`,
  3: `${CLD}/v1774894571/imagen_definitiva_origen_ABRIL_a8metw.png`,
  4: `${CLD}/v1774894571/Imagen_definitiva_origen_MAYO_xeqnvo.png`,
  5: `${CLD}/v1774894570/imagen_definitiva_origen_JUNIO_fssq65.png`,
  6: `${CLD}/v1774894578/imagen_definitiva_origen_JULIO_f7bl55.png`,
  7: `${CLD}/v1774894572/imagen_definitiva_origen_AGOSTO_ilss0u.png`,
  8: `${CLD}/v1774894573/imagen_definitiva_origen_SEPTIEMBRE_vbfqbj.png`,
  9: `${CLD}/v1774894574/imagen_definitiva_origen_OCTUBRE_dyz149.png`,
  10: `${CLD}/v1774894573/imagen_definitiva_origen_NOVIEMBRE_tao8un.png`,
  11: `${CLD}/v1774894574/imagen_definitiva_origen_DICIEMBRE_h9bzss.png`,
};

const MONTHLY_IMAGES_NIGHT = {
  0: `${CLD}/v1774894525/imagen_definitiva_origen_ENERO_NOCHE_sd14cm.png`,
  1: `${CLD}/v1774894526/imagen_definitiva_origen_FEBRERO_NOCHE_csypyv.png`,
  2: `${CLD}/v1774894525/imagen_definitiva_origen_MARZO_NOCHE_uo3tgw.png`,
  3: `${CLD}/v1774894524/imagen_definitiva_origen_ABRIL_NOCHE_jcdv40.png`,
  4: `${CLD}/v1774894523/imagen_definitiva_origen_MAYO_NOCHE_zav6a9.png`,
  5: `${CLD}/v1774894525/imagen_definitiva_origen_JUNIO_NOCHE_b7zaif.png`,
  6: `${CLD}/v1774894524/imagen_definitiva_origen_JULIO_NOCHE_zkdtck.png`,
  7: `${CLD}/v1774894529/imagen_definitiva_origen_AGOSTO_NOCHE_helft8.png`,
  8: `${CLD}/v1774894528/imagen_definitiva_origen_SEPTIEMBRE_NOCHE_fsmwl9.png`,
  9: `${CLD}/v1774894523/imagen_definitiva_OCTUBRE_NOCHE_ynd5lc.png`,
  10: `${CLD}/v1774894523/imagen_definitiva_origen_NOVIEMBRE_NOCHE_cuxeni.png`,
  11: `${CLD}/v1774894523/imagen_definitva_origen_DICIEMBRE_NOCHE_ie662h.png`,
};

const GardenSVG = ({ season = 2, timeOfDay = 'tarde', moon = {}, personal = {}, hoveredZone = null }) => {
  const isNight = timeOfDay === 'noche' || timeOfDay === 'madrugada';
  const currentMonth = new Date().getMonth();
  const bgImage = isNight ? MONTHLY_IMAGES_NIGHT[currentMonth] : MONTHLY_IMAGES_DAY[currentMonth];

  const fireflyCount = isNight ? 10 : (timeOfDay === 'tarde' ? 7 : 5);

  const fireflies = useMemo(() => Array.from({ length: 10 }, (_, i) => ({
    x: 10 + (i * 8.7 % 75),
    y: 8 + (i * 13.1 % 70),
    delay: (i * 1.9) % 12,
    driftDur: 15 + (i % 5) * 4,
    glowDur: 3 + (i % 4) * 1.5,
  })), []);

  const crystals = useMemo(() => Array.from({ length: 6 }, (_, i) => ({
    x: 6 + (i * 3 % 16),
    y: 40 + (i % 3) * 8,
    delay: i * 1.3,
  })), []);

  const shimmers = useMemo(() => Array.from({ length: 5 }, (_, i) => ({
    x: 28 + i * 8,
    y: 72 + (i % 3) * 5,
    delay: i * 2,
    dur: 7 + (i % 3) * 3,
  })), []);

  const mistWisps = useMemo(() => Array.from({ length: 5 }, (_, i) => ({
    x: 28 + (i * 9 % 35),
    y: 55 + (i % 3) * 12,
    delay: i * 2.5,
    dur: 11 + (i % 3) * 4,
  })), []);

  const luciernagas = useMemo(() => Array.from({ length: 14 }, (_, i) => ({
    x: 5 + (i * 7.3 % 85),
    y: 10 + (i * 11.7 % 65),
    delay: (i * 1.1) % 8,
    dartDur: 5 + (i % 5) * 1.5,
    flickerDur: 1.2 + (i % 4) * 0.4,
    size: 3 + (i % 3),
  })), []);

  return (
    <div className="garden-wrap" data-testid="garden-svg">
      <style>{`
        .garden-wrap{position:relative;width:100%;height:100vh;overflow:hidden}
        .garden-bg{width:100%;height:100vh;display:block;object-fit:cover;object-position:center 55%}
        .gfx{position:absolute;inset:0;z-index:5;pointer-events:none}

        @keyframes drift{
          0%{transform:translate(0,0)}
          25%{transform:translate(18px,-25px)}
          50%{transform:translate(-12px,-40px)}
          75%{transform:translate(20px,-15px)}
          100%{transform:translate(0,0)}
        }
        @keyframes ffPulse{
          0%,100%{opacity:.4;transform:scale(.7)}
          20%{opacity:1;transform:scale(1.15)}
          50%{opacity:.55;transform:scale(.8)}
          75%{opacity:.95;transform:scale(1.1)}
        }
        @keyframes breathe{
          0%,100%{opacity:.45}
          50%{opacity:.9}
        }
        @keyframes heartbeat{
          0%,100%{opacity:.35;transform:scale(.94)}
          50%{opacity:.8;transform:scale(1.08)}
        }
        @keyframes crystalUp{
          0%{opacity:.15;transform:translateY(0)}
          12%{opacity:.95}
          45%{opacity:.4;transform:translateY(-50px)}
          100%{opacity:0;transform:translateY(-100px)}
        }
        @keyframes riverSlide{
          0%{opacity:.2;transform:translateX(0)}
          20%{opacity:.85}
          50%{opacity:.45}
          80%{opacity:.75}
          100%{opacity:.15;transform:translateX(55px)}
        }
        @keyframes mistPulse{
          0%,100%{opacity:.3}
          50%{opacity:.65}
        }
        @keyframes mistDrift{
          0%{opacity:.2;transform:translate(0,0)}
          30%{opacity:.55}
          55%{opacity:.3;transform:translate(25px,-30px)}
          80%{opacity:.5}
          100%{opacity:.15;transform:translate(-12px,-45px)}
        }
        @keyframes luciDart{
          0%{transform:translate(0,0)}
          12%{transform:translate(35px,-18px)}
          28%{transform:translate(-20px,-45px)}
          40%{transform:translate(50px,-10px)}
          55%{transform:translate(-15px,25px)}
          68%{transform:translate(40px,-35px)}
          82%{transform:translate(-30px,10px)}
          100%{transform:translate(0,0)}
        }
        @keyframes luciFlicker{
          0%,100%{opacity:.2}
          8%{opacity:1}
          15%{opacity:.1}
          22%{opacity:.95}
          35%{opacity:.15}
          50%{opacity:.85}
          60%{opacity:.1}
          72%{opacity:.9}
          85%{opacity:.2}
          92%{opacity:.8}
        }
      `}</style>

      <img
        src={bgImage}
        alt={`Grimorio Vivo - Mes ${currentMonth + 1}`}
        className="garden-bg"
        draggable={false}
        data-testid="garden-bg-image"
      />

      <div className="gfx">
        {isNight && (
          <div style={{
            position: 'absolute', inset: 0,
            background: 'radial-gradient(ellipse at 50% 30%, transparent 20%, rgba(10,10,42,.2) 100%)',
          }}/>
        )}

        {/* === 1. TREE BREATHING — white-gold glow at tree roots (right) === */}
        <div data-testid="tree-breathing" style={{
          position: 'absolute', right: '8%', bottom: '15%',
          width: hoveredZone === 'tree' ? '28px' : '20px',
          height: hoveredZone === 'tree' ? '28px' : '20px',
          borderRadius: '50%',
          background: '#fff8e0',
          boxShadow: hoveredZone === 'tree'
            ? '0 0 60px 40px rgba(255,248,224,1), 0 0 120px 75px rgba(218,165,32,.7), 0 0 200px 120px rgba(218,165,32,.3)'
            : '0 0 40px 25px rgba(255,248,224,.9), 0 0 80px 50px rgba(218,165,32,.6), 0 0 150px 90px rgba(218,165,32,.25)',
          animation: 'breathe 11s ease-in-out infinite',
          transition: 'width .8s, height .8s, box-shadow .8s',
        }}/>
        <div style={{
          position: 'absolute', right: '18%', bottom: '8%',
          width: hoveredZone === 'tree' ? '20px' : '14px',
          height: hoveredZone === 'tree' ? '20px' : '14px',
          borderRadius: '50%',
          background: '#ffe8a0',
          boxShadow: hoveredZone === 'tree'
            ? '0 0 50px 30px rgba(255,232,160,.9), 0 0 100px 60px rgba(201,146,42,.5)'
            : '0 0 30px 18px rgba(255,232,160,.7), 0 0 70px 40px rgba(201,146,42,.35)',
          animation: 'breathe 11s ease-in-out infinite',
          animationDelay: '3s',
          transition: 'width .8s, height .8s, box-shadow .8s',
        }}/>
        {isNight && (
          <div style={{
            position: 'absolute', right: '12%', top: '20%',
            width: '10px', height: '10px', borderRadius: '50%',
            background: '#fffad0',
            boxShadow: '0 0 25px 15px rgba(255,250,208,.6), 0 0 60px 35px rgba(255,215,0,.25)',
            animation: 'breathe 9s ease-in-out infinite',
            animationDelay: '1s',
          }}/>
        )}

        {/* === 2. FIREFLIES — bright white-gold points with warm halos === */}
        {fireflies.slice(0, fireflyCount).map((f, i) => (
          <div key={`ff${i}`} style={{
            position: 'absolute',
            left: `${f.x}%`, top: `${f.y}%`,
            animation: `drift ${f.driftDur}s ease-in-out infinite`,
            animationDelay: `${f.delay}s`,
          }}>
            <div style={{
              width: '10px', height: '10px',
              borderRadius: '50%',
              background: isNight ? '#fffff0' : '#fff8d0',
              boxShadow: isNight
                ? '0 0 8px 4px rgba(255,255,240,1), 0 0 20px 12px rgba(255,250,200,.7), 0 0 45px 25px rgba(255,240,160,.3)'
                : '0 0 8px 4px rgba(255,248,208,1), 0 0 20px 12px rgba(255,230,120,.6), 0 0 40px 22px rgba(255,215,0,.2)',
              animation: `ffPulse ${f.glowDur}s ease-in-out infinite`,
              animationDelay: `${f.delay}s`,
            }}/>
          </div>
        ))}

        {/* === 2b. LUCIÉRNAGAS NOCTURNAS — small, fast, erratic fireflies === */}
        {isNight && luciernagas.map((l, i) => (
          <div key={`luci${i}`} style={{
            position: 'absolute',
            left: `${l.x}%`, top: `${l.y}%`,
            animation: `luciDart ${l.dartDur}s ease-in-out infinite`,
            animationDelay: `${l.delay}s`,
          }}>
            <div style={{
              width: `${l.size}px`, height: `${l.size}px`,
              borderRadius: '50%',
              background: '#fffde0',
              boxShadow: `0 0 ${l.size}px ${l.size}px rgba(255,253,224,.9), 0 0 ${l.size * 3}px ${l.size * 2}px rgba(255,240,140,.5)`,
              animation: `luciFlicker ${l.flickerDur}s ease-in-out infinite`,
              animationDelay: `${l.delay + 0.3}s`,
            }}/>
          </div>
        ))}

        {/* === 3. RIVER REFLECTIONS — bright white-silver shimmer on water === */}
        {shimmers.map((r, i) => (
          <div key={`rv${i}`} style={{
            position: 'absolute',
            left: `${r.x}%`, top: `${r.y}%`,
            width: '10px', height: '5px', borderRadius: '50%',
            background: isNight ? '#d8e8ff' : '#fffff5',
            boxShadow: isNight
              ? '0 0 10px 5px rgba(216,232,255,.7), 0 0 25px 12px rgba(180,210,255,.35)'
              : '0 0 10px 5px rgba(255,255,245,.7), 0 0 25px 12px rgba(255,248,220,.35)',
            animation: `riverSlide ${r.dur}s ease-in-out infinite`,
            animationDelay: `${r.delay}s`,
          }}/>
        ))}

        {/* === 4. CRYSTAL DUST — pink/gold sparks ascending from crystals === */}
        {crystals.map((c, i) => (
          <div key={`cr${i}`} style={{
            position: 'absolute',
            left: `${c.x}%`, top: `${c.y}%`,
            width: '7px', height: '7px', borderRadius: '50%',
            background: i % 2 === 0 ? '#ffcce0' : '#ffe480',
            boxShadow: i % 2 === 0
              ? '0 0 8px 4px rgba(255,204,224,.8), 0 0 20px 10px rgba(240,176,200,.35)'
              : '0 0 8px 4px rgba(255,228,128,.8), 0 0 20px 10px rgba(255,215,0,.35)',
            animation: `crystalUp ${8 + (i % 3) * 3}s ease-out infinite`,
            animationDelay: `${c.delay}s`,
          }}/>
        ))}

        {/* === 5. PORTAL HEARTBEAT — bright warm light pulsing from doorway === */}
        <div data-testid="portal-heartbeat" style={{
          position: 'absolute', left: '10%', top: '30%',
          width: hoveredZone === 'portal' ? '26px' : '18px',
          height: hoveredZone === 'portal' ? '26px' : '18px',
          borderRadius: '50%',
          background: '#fff5d0',
          boxShadow: hoveredZone === 'portal'
            ? '0 0 50px 30px rgba(255,245,208,1), 0 0 100px 65px rgba(255,220,100,.65), 0 0 180px 100px rgba(245,200,66,.3)'
            : '0 0 35px 20px rgba(255,245,208,.9), 0 0 70px 45px rgba(255,220,100,.5), 0 0 130px 75px rgba(245,200,66,.2)',
          animation: 'heartbeat 5s ease-in-out infinite',
          transformOrigin: 'center',
          transition: 'width .8s, height .8s, box-shadow .8s',
        }}/>

        {/* === 6. BRUMA DE AGUA — cool white mist rising from waterfall === */}
        <div data-testid="water-mist-base" style={{
          position: 'absolute', left: '30%', top: '60%',
          width: '20px', height: '14px', borderRadius: '50%',
          background: isNight ? 'rgba(200,215,240,.6)' : 'rgba(255,255,252,.65)',
          boxShadow: isNight
            ? '0 0 60px 45px rgba(200,215,240,.35), 0 0 130px 90px rgba(180,200,230,.15)'
            : '0 0 60px 45px rgba(255,255,252,.4), 0 0 130px 90px rgba(255,250,245,.18)',
          animation: 'mistPulse 12s ease-in-out infinite',
        }}/>
        {mistWisps.map((m, i) => (
          <div key={`mist${i}`} style={{
            position: 'absolute',
            left: `${m.x}%`, top: `${m.y}%`,
            width: '14px', height: '10px', borderRadius: '50%',
            background: isNight ? 'rgba(200,215,240,.5)' : 'rgba(255,255,250,.55)',
            boxShadow: isNight
              ? '0 0 45px 30px rgba(200,215,240,.25), 0 0 90px 55px rgba(180,200,230,.1)'
              : '0 0 45px 30px rgba(255,255,250,.3), 0 0 90px 55px rgba(255,250,245,.12)',
            animation: `mistDrift ${m.dur}s ease-in-out infinite`,
            animationDelay: `${m.delay}s`,
          }}/>
        ))}
      </div>

      <div
        className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none"
        style={{ background: 'linear-gradient(to bottom, transparent, #faf8f4)', zIndex: 6 }}
      />
    </div>
  );
};

export default GardenSVG;
